import { IGetCargoHabilidadesUseCase } from "../../../presentation/useCases/read/get_cargo_habilidades_use_case";
import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { CargoHabilidade } from "../../models/cargo_habilidade";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * GetCargoHabilidadesUseCase
 */

export class GetCargoHabilidadesUseCase extends BasePaginatedUseCase<CargoHabilidade> implements IGetCargoHabilidadesUseCase {
  constructor(private readonly repository: IRhRepository) {
    super();
  }

  async getCargoHabilidades(
    idCargo: number | null,
    page: number,
    rowsPerPage: number,
  ): Promise<void> {
    const response = await this.repository.getCargoHabilidades(
      idCargo,
      page,
      rowsPerPage,
    );

    this._items = response.items;
    this._totalItems = response.totalItems;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
    this._totalPages = response.totalPages;
  }
}
